import { FC } from 'react';

import { LoadingLayout } from '../layouts/LoadingLayout';

export const LoadingPage: FC = () => <LoadingLayout />;
